import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["className", "selectRef"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AvBaseInput } from 'availity-reactstrap-validation';
import SelectBox from '../SelectBox';
import get from 'lodash/get';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
var AvSelect = /*#__PURE__*/function (_AvBaseInput) {
  _inheritsLoose(AvSelect, _AvBaseInput);
  function AvSelect() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _AvBaseInput.call.apply(_AvBaseInput, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "optionsContainsValue", function (props, value) {
      var valueKey = _this.getValueKey(props);
      return !!find(props.options, [valueKey, value]);
    });
    _defineProperty(_assertThisInitialized(_this), "getOptionValue", function (option) {
      return _this.props.raw && !_this.props.valueKey ? option : get(option, _this.getValueKey(_this.props), option);
    });
    _defineProperty(_assertThisInitialized(_this), "getOptionLabel", function (option) {
      return option[_this.getLabelKey(_this.props)];
    });
    _defineProperty(_assertThisInitialized(_this), "prepValue", function (value, digIfMulti) {
      if (digIfMulti === void 0) {
        digIfMulti = true;
      }
      if (_this.props.isMulti && digIfMulti && Array.isArray(value)) {
        return value.map(_this.prepValue, false);
      }
      if (_this.props.raw || _this.props.loadOptions) {
        return value;
      }
      var valueKey = _this.getValueKey();
      return get(value, valueKey, value);
    });
    return _this;
  }
  var _proto = AvSelect.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newValue = nextProps.value !== undefined ? nextProps.value : this.value;
    if (newValue !== this.value) {
      this.value = newValue;
      this.setState({
        value: newValue
      });
      this.validate();
    }
    if (!isEqual(nextProps, this.props)) {
      this.updateValidations(nextProps);
    }
  };
  _proto.getDefaultValue = function getDefaultValue() {
    var defaultValue = '';
    if (this.props.isMulti) {
      defaultValue = [];
    }
    var value = this.props.defaultValue;
    if (typeof value === 'undefined' && this.context.FormCtrl) {
      value = this.context.FormCtrl.getDefaultValue(this.props.name);
    }
    return typeof value === 'undefined' ? defaultValue : value;
  };
  _proto.getValueKey = function getValueKey(nextProps) {
    if (nextProps === void 0) {
      nextProps = this.props;
    }
    return get(nextProps, 'valueKey', 'value');
  };
  _proto.getLabelKey = function getLabelKey(nextProps) {
    if (nextProps === void 0) {
      nextProps = this.props;
    }
    return get(nextProps, 'labelKey', 'label');
  };
  _proto.onBlurHandler = function onBlurHandler(value) {
    if (this.getValidationEvent() === 'onBlur') {
      this.validate();
    }
    if (this.context.FormCtrl) this.context.FormCtrl.setTouched(this.props.name);
    return this.props.onBlur && this.props.onBlur(value);
  };
  _proto.onFocusHandler = function onFocusHandler(value) {
    if (this.getValidationEvent() === 'onFocus') {
      this.validate();
    }
    return this.props.onFocus && this.props.onFocus(value);
  };
  _proto.onInputHandler = function onInputHandler() {
    if (this.props.onInputChange) {
      var _this$props;
      (_this$props = this.props).onInputChange.apply(_this$props, arguments);
    }
  };
  _proto.onChangeHandler = function onChangeHandler(inputValue) {
    var value = this.prepValue(inputValue);
    if (this.props.isMulti) {
      var max = this.props.maxLength || this.props.max;
      if (value.length > max) {
        return;
      }
    }
    _AvBaseInput.prototype.onChangeHandler.call(this, value);
  };
  _proto.getValue = function getValue() {
    return this.value === null ? '' : this.value;
  };
  _proto.findOptionFromValue = function findOptionFromValue(value, options) {
    var _this2 = this;
    return Array.isArray(options) && options.filter(function (option) {
      return _this2.getOptionValue(option) === value;
    })[0];
  };
  _proto.getViewValue = function getViewValue() {
    var _this3 = this;
    if (this.props.raw || this.props.loadOptions || !this.props.options) return this.state.value;
    if (this.props.isMulti && Array.isArray(this.state.value)) {
      return this.state.value.map(function (value) {
        return _this3.findOptionFromValue(value, _this3.props.options) || value;
      });
    }
    return this.findOptionFromValue(this.state.value, this.props.options) || this.state.value;
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      className = _this$props2.className,
      selectRef = _this$props2.selectRef,
      attributes = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var touched = this.context.FormCtrl && this.context.FormCtrl.isTouched(this.props.name);
    var hasError = this.context.FormCtrl && this.context.FormCtrl.hasError(this.props.name);
    var classes = className;
    if (this.context.FormCtrl) {
      classes = classNames(className, 'av-select', touched ? 'is-touched' : 'is-untouched', this.context.FormCtrl.isDirty(this.props.name) ? 'is-dirty' : 'is-pristine', this.context.FormCtrl.isBad(this.props.name) ? 'is-bad-input' : null, hasError ? 'av-invalid' : 'av-valid', touched && hasError && 'is-invalid');
    }
    return /*#__PURE__*/React.createElement(SelectBox, _extends({
      ref: selectRef,
      className: classes,
      getOptionLabel: this.getOptionLabel,
      getOptionValue: this.getOptionValue,
      closeMenuOnSelect: !attributes.isMulti
    }, attributes, this.getValidatorProps(), {
      value: this.getViewValue()
    }));
  };
  return AvSelect;
}(AvBaseInput);
_defineProperty(AvSelect, "contextTypes", {
  FormCtrl: PropTypes.object
});
_defineProperty(AvSelect, "propTypes", Object.assign({}, AvBaseInput.propTypes, {
  options: PropTypes.array,
  loadOptions: PropTypes.func,
  raw: PropTypes.bool
}));
export default AvSelect;